import script from "./ApprovePost.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovePost.vue?vue&type=script&setup=true&lang=js"

import "./ApprovePost.vue?vue&type=style&index=0&id=92b278ce&lang=scss"

const __exports__ = script;

export default __exports__